var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobham({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.6344V10.1345H17.5V11.6344H0.5ZM0.5 6.74981V5.24986H17.5V6.74981H0.5ZM0.5 1.86521V0.365234H17.5V1.86521H0.5Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobham);
export default __webpack_public_path__ + "static/media/mobham.7d526bfc6cafa13b55e8b57a332976b1.svg";
export { ForwardRef as ReactComponent };